import BaseHeader from "@/components/Header/BaseHeader";
import RecommendedBy from "@/components/Intervention/RecommendedBy";
import WithoutTemplate from "@/components/Intervention/WithoutTemplate";
import { useGetAsset } from "@/entities/asset";
import {
  INTERVENTION_INCLUDES,
  useGetIntervention,
} from "@/entities/intervention";
import InterventionEdit from "@/features/Interventions/InterventionEdit";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import InterventionBreadcrumb from "@/modules/intervention/intervention-breadcrumb";
import { InterventionHeaderActions } from "@/modules/intervention/intervention-header-actions";
import { InterventionIndicator } from "@/modules/intervention/intervention-indicator";
import { PageItemContextGate } from "@/modules/page-item-context-gate";
import { useSidePanel } from "@/modules/side-panel";
import { useIdParam } from "@/services/router";

import InterventionContext from "./InterventionContext";
import InterventionDetailsTabs from "./InterventionDetailsTabs";

const Details = () => {
  const id = useIdParam();
  const { openSidePanel } = useSidePanel();

  const InterventionIncludes = [
    INTERVENTION_INCLUDES.PROJECT,
    INTERVENTION_INCLUDES.FOLLOWUP,
  ].join(",");

  const {
    isLoading: isInterventionLoading,
    intervention,
    context,
    error,
  } = useGetIntervention(id, {
    params: {
      include: InterventionIncludes,
    },
  });

  const { isLoading: isAssetLoading, asset } = useGetAsset(
    intervention?.asset_id
  );

  const isLoading = isInterventionLoading || isAssetLoading;

  const onAddTemplateClick = () => {
    openSidePanel({
      title: intervention?.name,
      component: <InterventionEdit interventionId={intervention?.id} />,
    });
  };

  return (
    <PageItemContextGate
      model="intervention"
      itemContext={context}
      queryError={error}
    >
      <InterventionContext.Provider value={intervention}>
        <div className="intervention-details-wrapper">
          <BaseHeader
            title={intervention?.name}
            afterTitle={
              <InterventionIndicator intervention={intervention} isBig />
            }
            breadcrumb={
              <>
                <InterventionBreadcrumb intervention={intervention} />
                <RecommendedBy
                  recommendedBy={intervention?.recommended_by}
                  loading={isLoading}
                />
              </>
            }
            loading={isLoading}
            extra={
              <InterventionHeaderActions
                intervention={intervention}
                loading={isLoading}
              />
            }
            wrapExtra={300}
          />
          {intervention?.intervention_template_id ? (
            <AppLayoutPage>
              <InterventionDetailsTabs
                intervention={intervention}
                interventionAsset={asset}
                loading={isLoading}
              />
            </AppLayoutPage>
          ) : (
            <WithoutTemplate
              loading={isLoading}
              onButtonClick={onAddTemplateClick}
            />
          )}
        </div>
      </InterventionContext.Provider>
    </PageItemContextGate>
  );
};

export default Details;
